import { Item } from './GroupedCombobox';
import { Optional } from '@/utils/types';

type Args<DataItem, Metadata> = {
	data: DataItem[] | undefined;
	mapper: (d: DataItem) => Item<Metadata>;
	searchPredicate: (d: DataItem, searchQuery: Optional<string>) => boolean;
	selectedId: Optional<string>;
	shouldFilter?: boolean;
	selectedItemPredicate?: (item: Item<Metadata>) => boolean;
	searchQuery?: Optional<string>;
};

type ReturnValue<Metadata> = {
	selectedItem: Optional<Item<Metadata>>;
	items: Item<Metadata>[];
};

export default function useGroupedCombobox<DataItem, Metadata>({
	data = [],
	mapper,
	searchQuery,
	selectedId,
	searchPredicate,
	shouldFilter = true,
	selectedItemPredicate
}: Args<DataItem, Metadata>): ReturnValue<Metadata> {
	const mapped = data.map(mapper);

	const predicate = selectedItemPredicate ?? (el => el.id === selectedId);
	const selectedItem = mapped.find(predicate);

	const filtered = shouldFilter ? mapped?.filter((_, i) => searchPredicate(data[i], searchQuery)) : mapped;

	return { items: filtered, selectedItem };
}
